import React from "react";
import { Box, Button } from "@mui/material";
import { ReactComponent as CheckCircleIcon } from "../../assets/dashboardIcons/dotIcon.svg"




const DashboardCard = ({ dummyData, infoFields, file, open, setOpen, imageFile }) => {
    // console.log(infoFields, " console.log()", imageFile)
    return (
        <Box className="weightBoxMain">
            {infoFields?.map((item, index) => (

                <>
                    <Box className="weightBox">
                        <div className="weightBox__titleSmall">
                            <p style={{ minHeight: (index === 3 && file && imageFile ) ? "auto" : "30px" }} color="textSecondary">
                                {item.label}
                            </p>
                            <div className="weightBox__dots">
                                {item.showIcon && <CheckCircleIcon />}
                            </div>
                        </div>
                        <div className="weightBox__uploadedImages">
                            {(index === 3 && file) && (
                                imageFile ? (<Box >
                                    <img
                                        src={imageFile}
                                    />
                                    <p onClick={() => setOpen(!open)}>Verifica conformità</p>
                                </Box>
                                ) : (
                                    <Button
                                        onClick={() => setOpen(!open)}
                                        className="caricafile-label"
                                        variant="outlined"
                                        component="label"
                                    >
                                        Carica file
                                    </Button>
                                )
                            )}
                           <h4 className="count"> {item.key}</h4>
                    </div>
                    </Box >
                </>
            ))
            }

            <Box className="weightBox BigBox">
                <h3 color="primary">
                    Cosa c’è da fare?
                </h3>
                {/* <List dense> */}
                {dummyData.tasks.map((task, index) => (
                    <div className="weightBox__question" key={index} disableGutters>
                        {task}
                        {/* primary={task}
                                 primaryTypographyProps={{ variant: "body2", sx: { color: "blue" } }} */}

                    </div>
                ))}
                {/* </List> */}
            </Box>
        </Box >
    );
};

export default DashboardCard;
